<div class="modal-header border-0 pb-2">
    <label class="d-block">User permissions & assignments for:</label>
    <button type="button" class="btn-close" (click)="dismiss()" aria-label="Close"></button>
</div>
<div class="d-flex align-items-center px-3" *ngIf="user">
    <div class="me-2" *ngIf="!user.backgroundImage">
        <div class="avatar avatar-sm">{{user.initials}}</div>
    </div>
    <div class="me-2" *ngIf="user.backgroundImage">
        <div class="avatar avatar-sm" [ngStyle]="{'background-image': user.backgroundImage}"></div>
    </div>
    <div class="d-flex align-items-center">
        <h3 class="m-0 me-3 text-strong">{{user.fullName}}</h3>
        <button type="button" (click)="viewAssignment(null)" class="btn btn-round btn-sm btn-primary text-uppercase text-strong hvr-grow"><i class="far fa-user-plus"></i> New Assignment</button>
    </div>
</div>
<hr class="mb-0" />
<div class="modal-body">
    <div class="row align-items-end gx-2 mb-3">
        <div class="col-md mb-3 mb-md-0 mobiscroll-select">
            <label class="form-label d-block">Top Level Account</label>
            <input mbsc-select type="text" class="mobi-input form-control form-control-lg" placeholder="Select Account" [(ngModel)]="filter.accountId" placeholder="Select Top Level Account" [data]="accounts" [mbscOptions]="selectOptions" />
        </div>
        <div class="col-md-2 mb-3 mb-md-0 mobiscroll-select">
            <label class="form-label">Whitelist/Blacklist</label>
            <div class="w-100" ngbDropdown>
                <button class="btn btn-white btn-lg w-100" type="button" id="dropdownMenuButton1" ngbDropdownToggle aria-expanded="false">
                    <span>{{filter.userPermission.text}}</span>
                </button>
                <ul class="w-100" ngbDropdownMenu aria-labelledby="dropdownMenuButton1">
                    <ng-container *ngFor="let f of userPermissionList">
                        <li *ngIf="filter.userPermission.value !== f.value"><a ngbDropdownItem class="dropdown-item" href="javascript:void(0)" (click)="selectUserPermission(f)">{{f.text}}</a></li>
                    </ng-container>
                </ul>
            </div>
        </div>
        <div class="col-xl mt-3 mt-xl-0">
            <div class="row gx-2 justify-content-xxl-end justify-content-center search-btns">
                <div class="col-auto">
                    <button type="button" class="btn btn-secondary btn-round btn-lg text-uppercase text-strong" (click)="showTheList()"><i class="far fa-search"></i> Search</button>
                </div>
                <div class="col-auto">
                    <button type="button" class="btn btn-white btn-round btn-lg text-uppercase text-strong" (click)="hideTheList()"><i class="far fa-times"></i> Clear</button>
                </div>
            </div>
        </div>
    </div>
    <hr />
    <div class="p-3 text-center" *ngIf="!showList">
        <h3>Search Assignments</h3>
        <p>Enter search parameters above to find assignments.</p>
        <div class="mx-auto">
            <button type="button" class="btn btn-round btn-outline-secondary text-uppercase text-strong" (click)="showTheList()">Show All</button>
        </div>
    </div>
    <table class="table table-striped table-hover align-middle m-0" *ngIf="showList">
        <thead>
            <tr>
                <th class="nowrap">
                    <table-sorting [(col)]="filter.sortedColumn" [(dir)]="filter.sortedDirection" colName="Entity" [cb]="loadList"></table-sorting>
                </th>
                <th class="nowrap">Permissions</th>
                <th class="nowrap">Assigned to</th>
                <th class="nowrap">Inherited Entities</th>
                <th class="text-right"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let assignment of results.data" [ngClass]="{'blacklisted': assignment.permissions.length == 0}">
                <td><a href="javascript:void(0)" (click)="manageEntity(assignment.entityId)"><i class="far fa-folder-tree"></i> {{assignment.entityName}}</a><br *ngIf="assignment.streetAddress" />{{assignment.streetAddress}}</td>
                <td>
                    <ul class="list-unstyled d-flex m-0">
                        <li class="me-1" *ngFor="let permission of assignment.permissions">
                            <h5 class="m-0"><span class="badge rounded-pill bg-dark">{{permission}}</span></h5>
                        </li>
                        <li class="me-1" *ngIf="assignment.permissions.length == 0">
                            <h5 class="m-0"><span class="badge rounded-pill bg-black">Blacklisted Here</span></h5>
                        </li>
                    </ul>
                </td>
                <td>
                    <a href="javascript:void(0)" (click)="manageEntity(assignment.inheritId)" *ngIf="assignment.entityId != assignment.inheritId"><i class="far fa-folder-tree"></i> {{assignment.inheritName}}</a>
                    <ng-container *ngIf="assignment.entityId == assignment.inheritId">Here ({{assignment.entityName}})</ng-container>
                </td>
                <td>
                    <ng-container *ngIf="assignment.entityId == assignment.inheritId">{{assignment.entityCount}}
                    </ng-container>
                </td>
                <td class="text-right">
                    <div ngbDropdown>
                        <button class="btn btn-lg btn-white btn-shadow action-btn no-caret" type="button" id="dropdownMenuButton1" ngbDropdownToggle aria-expanded="false">
                            <i class="far fa-ellipsis-v"></i>
                        </button>
                        <ul class="dropdown-menu-end" ngbDropdownMenu aria-labelledby="dropdownMenuButton1">
                            <li *ngIf="assignment.permissions.length != 0"><a class="dropdown-item" (click)="viewAssignment(assignment.entityId)" href="javascript:void(0)"><i class="far fa-pencil fa-fw"></i> Edit Permissions</a>
                            </li>
                            <li *ngIf="assignment.permissions.length != 0"><a class="dropdown-item" (click)="blacklistEntity(assignment.entityId)" href="javascript:void(0)"><i class="far fa-user-times fa-fw"></i> Blacklist</a></li>
                            <li><a class="dropdown-item" (click)="resetPermissions(assignment.entityId)" href="javascript:void(0)"><i class="far fa-user-plus fa-fw"></i> Reset to Inherit</a></li>
                        </ul>
                    </div>
                </td>
            </tr>
            <tr *ngIf="results.data.length == 0">
                <td colspan="5">No results found.</td>
            </tr>
        </tbody>
    </table>
    <div *ngIf="showList" class="p-3 d-md-flex align-items-center justify-content-md-between justify-content-center text-center text-md-left">
        <p class="m-md-0 mb-3">{{filter.showing(results.recordsFiltered)}}</p>
        <ngb-pagination [(page)]="filter.page" [pageSize]="filter.pageSize" [collectionSize]="results.recordsFiltered" (pageChange)="loadList(false)" size="lg" [maxSize]="5" [rotate]="true" [ellipses]="false" [boundaryLinks]="true"></ngb-pagination>
    </div>
</div>